import { Abstrap } from '../../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'td' };

class TableCell extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-table__cell',
            className,
        ];
    }

}

TableCell.propTypes = propTypes;

TableCell.defaultProps = defaultProps;

export default TableCell;
